import commonUtil from '../../../../../../utils/commonUtil';

export const GET_EVENT_DETAILS = 'GET_EVENT_DETAILS';
export const SAVE_OWNER_DETAILS = 'SAVE_OWNER_DETAILS'
export const ADD_CO_OWNER_LOAD = 'ADDCOOWNER_LOAD';
const SAVEOWNERDETAILS = '/api/EditEvent/saveOwnerDetails';
const ADDCOOWNERTOEVENT = '/api/EditEvent/addCoOwnerToEvent';

export function getEventDetails(eventId, profileId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.profileId = profileId;
  return {
    types: [GET_EVENT_DETAILS],
    promise: client => client.post('/api/EditEvent/eventDetails', {
      data: (payload),
    }), // params not used, just shown as demonstration
  };
}

export function updateOwnerDetails(userDetail, profileId,eventID) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.ownerId = userDetail.ownerId;
  payload.ownerTitle = userDetail.ownerTitle;
  if (userDetail.iscoOwner === 'false' || userDetail.ownerHasPermission) {
    payload.ownerHasPermission = true;
    payload.ownerEmail = userDetail.ownerEmail;
  } else {
    payload.ownerEmail = userDetail.ownerEmail;
    payload.ownerHasPermission = userDetail.ownerHasPermission;
    //bff accepting boolean
  }
  if (userDetail.profileId || profileId) {
    payload.profileId = userDetail.profileId || profileId;
  }
  payload.ownerfirstName = userDetail.ownerfirstName;
  payload.ownerlastName = userDetail.ownerlastName;
  payload.eventId = eventID;
  // payload.nickName = userDetail.ownerNickName;
  payload.ownerMotherName = userDetail.ownerMotherName;
  // payload.ownerDateofbirth = userDetail.ownerDateofbirth;
  payload.ownerPhone = userDetail.ownerPhone;
  return commonUtil.triggerServerRequest({ url: SAVEOWNERDETAILS, method: 'POST', data: payload });
}

export function addCoOwnerDetails(userDetail, profileId, eventId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.eventId = eventId;
  payload.title = userDetail.ownerTitle;
  if (userDetail.ownerHasPermission) {
    payload.hasPermission = 'true';
  }
  if (userDetail.profileId || profileId) {
    payload.profileId = userDetail.profileId || profileId;
  }
  if(userDetail.iscoOwner){
     payload.iscoowner = true;
  }
  if(userDetail.isCelebrity){
     payload.isCelebrity = true;
  }
  payload.firstName = userDetail.ownerfirstName;
  payload.lastName = userDetail.ownerlastName;
  payload.motherName = userDetail.ownerMotherName;
  // payload.celebdateofbirth = userDetail.ownerDateofbirth;
  payload.phone = userDetail.ownerHasPermission ? userDetail.ownerPhone : '';
  payload.ownerEmail = userDetail.ownerHasPermission ? userDetail.ownerEmail : '';
  // payload.celebnickName = userDetail.ownerNickName;
  payload.ownerLabel = userDetail.ownerLabel;
  if(userDetail.celebrityUpdated){
    payload.celebrityUpdated = userDetail.celebrityUpdated;
  }
  return commonUtil.triggerServerRequest({ url: ADDCOOWNERTOEVENT, method: 'POST', data: payload });
}